<template>
    <div class="auth-fluid authentication-bg pb-0">
        <!-- Auth left content -->
        <div class="auth-fluid-form-box">
            <div class="card-body d-flex flex-column h-100 gap-3">
                <div class="auth-brand text-center">
                    <img :src="`${$logoDir}logo-auth.png`" alt="HAXO" />
                </div>
                <div class="d-flex justify-content-end">
                    <LangSwitcher />
                </div>
                <router-view></router-view>
            </div>
        </div>
        <!-- Auth right content -->
        <div class="auth-fluid-right text-center">
        </div>
    </div>
</template>

<script>
import LangSwitcher from '@/components/langSwitcher.vue';

export default {
    name: 'AuthPage',
    components: { LangSwitcher },
}
</script>
